/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-04-26 16:20:44
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-09-16 15:11:31
 */

import React from "react";
import ReactDOM from "react-dom";

import { Layout, Menu } from "antd";
import {
  // UserOutlined,
  // LaptopOutlined,
  // NotificationOutlined,
  RedEnvelopeOutlined,
  createFromIconfontCN,
} from "@ant-design/icons";

import Routes from "./routes";

import "./layout.scss";
import $axios from "utils/request";
import { ORDER_ICONS } from "utils/config";

const { SubMenu } = Menu;
const { Header, Content, Sider, Footer } = Layout;

// const MenuIcon = createFromIconfontCN({
//   scriptUrl: ORDER_ICONS,
// });

export default class LayoutContainer extends React.Component {
  state = {
    menus: [],
  };
  componentDidMount() {
    const { REACT_APP_WORKBENCH_API_URL } = process.env;
    $axios({ url: `${REACT_APP_WORKBENCH_API_URL}erp` }).then((res: any) => {
      this.setState({
        menus: res.data,
      });
    });
  }

  render() {
    return (
      <Layout>
        <Sider width={180} className="site-layout-background">
          <div className="logo"></div>
          <Menu
            theme="dark"
            mode="inline"
            // defaultSelectedKeys={["1"]}
            // defaultOpenKeys={["sub1"]}
            style={{ height: "100%", borderRight: 0 }}
          >
            {this.state.menus.length > 0 &&
              this.state.menus.map((menu: any, index: any) => {
                return (
                  <SubMenu
                    key={index}
                    title={
                      <span>
                        {/* <MenuIcon type={menu.icon} /> */}
                        {/* {React.createElement(MenuIcon, { type: "icon-xiaoxi" })} */}
                        {/* {React.createElement(MenuIcon, { type: menu.icon })} */}
                        {/* {menu.icon} */}
                        {menu.title}
                      </span>
                    }
                  >
                    {menu.child &&
                      menu.child.map((child: any, index: any) => {
                        return (
                          <Menu.Item key={index}>
                            <a
                              target="_blank"
                              href={
                                child.uri ||
                                "http://admin.cattour.net/user/login_dingtalk"
                              }
                            >
                              {child.title}
                            </a>
                          </Menu.Item>
                        );
                      })}
                  </SubMenu>
                );
              })}
          </Menu>
        </Sider>

        <Layout>
          <Header className="site-layout-background"></Header>
          <Layout style={{ padding: "0 24px 24px", margin: "16px 0" }}>
            <Content
              className="site-layout-background"
              style={{
                padding: 30,
                margin: 0,
                minHeight: 820,
              }}
            >
              <Routes />
            </Content>
            <Footer style={{ textAlign: "center" }}>
              Workbench ©2020 Powered by Lanmao FED
            </Footer>
          </Layout>
        </Layout>
      </Layout>
    );
  }
}
